import { render, staticRenderFns } from "./form1.vue?vue&type=template&id=d4a6bb04&scoped=true&"
import script from "./form1.vue?vue&type=script&lang=js&"
export * from "./form1.vue?vue&type=script&lang=js&"
import style0 from "./form1.vue?vue&type=style&index=0&id=d4a6bb04&scoped=true&lang=css&"
import style1 from "./form1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a6bb04",
  null
  
)

export default component.exports